export default "__VITE_ASSET__fUqXUuyM__"